/* ==========================================================================
   SiliDog custom homepage — interactivity (Horizon theme asset)
   Loaded once on the homepage via theme.liquid (gated to template index).
   DATA-DRIVEN: reads content rendered by the Liquid sections (data-* attrs,
   rendered review cards) so Theme-Editor block edits flow through with no
   JS changes. Tokens are --sd-* on :root; the scroll palette shift mutates
   those on documentElement so every .silidog-home section updates together.
   ========================================================================== */
(function () {
    'use strict';

    /* ===================================================================
       1. Bundle builder — products come from the rendered .bp-card[data-key]
       =================================================================== */
    var BUNDLE = {};            // { key: {name, img, price} } built from DOM
    var pack = [];              // [{key, line1, line2}]

    function discountRate(count) {
        if (count >= 4) return 0.20;
        if (count === 3) return 0.15;
        if (count === 2) return 0.10;
        return 0;
    }
    function money(n) { return '$' + n.toFixed(2); }
    function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function syncAdd(key) {
        var nameEl = document.getElementById('n-' + key);
        var addEl = document.getElementById('add-' + key);
        if (nameEl && addEl) addEl.disabled = nameEl.value.trim().length === 0;
    }

    function addToPack(key) {
        var nameEl = document.getElementById('n-' + key);
        var phoneEl = document.getElementById('p-' + key);
        if (!nameEl) return;
        var line1 = nameEl.value.trim();
        if (!line1) return;
        pack.push({ key: key, line1: line1, line2: phoneEl ? phoneEl.value.trim() : '' });
        nameEl.value = ''; if (phoneEl) phoneEl.value = '';
        var addEl = document.getElementById('add-' + key);
        if (addEl) addEl.disabled = true;
        var card = document.getElementById('card-' + key);
        if (card) { card.classList.remove('added'); void card.offsetWidth; card.classList.add('added'); }
        renderBundle();
    }

    function removeFromPack(i) { pack.splice(i, 1); renderBundle(); }

    function updateProgress(count) {
        var fill = document.getElementById('bprFill');
        if (fill) {
            var FILL = { 0: 0, 1: 16.66, 2: 33.33, 3: 66.66 };
            fill.style.width = (count >= 4 ? 100 : FILL[count]) + '%';
        }
        document.querySelectorAll('.bpr-node').forEach(function (n) {
            n.classList.toggle('reached', count >= parseInt(n.dataset.at, 10));
        });
        var status = document.getElementById('bprStatus');
        if (status) {
            var st;
            if (count === 0) st = 'Add <b>2 tags</b> to unlock <b>10% off</b>';
            else if (count === 1) st = 'Add <b>1 more</b> to unlock <b>10% off</b>';
            else if (count === 2) st = 'Add <b>1 more</b> for <b>15% off</b>';
            else if (count === 3) st = 'Add <b>1 more</b> for <b>20% off + free shipping</b>';
            else st = '🎉 Max savings unlocked — <b>20% off + free shipping</b>';
            status.innerHTML = st;
        }
    }

    function renderBundle() {
        var count = pack.length;
        updateProgress(count);

        var subtotal = pack.reduce(function (s, it) { return s + (BUNDLE[it.key] ? BUNDLE[it.key].price : 0); }, 0);
        var rate = discountRate(count);
        var discount = subtotal * rate;
        var freeShip = count >= 4;
        var total = subtotal - discount;

        var t2 = document.getElementById('tier-2'), t3 = document.getElementById('tier-3'), t4 = document.getElementById('tier-4');
        if (t2) t2.classList.toggle('reached', count >= 2);
        if (t3) t3.classList.toggle('reached', count >= 3);
        if (t4) t4.classList.toggle('reached', count >= 4);

        var empty = document.getElementById('bundleEmpty');
        var list = document.getElementById('bundleList');
        var totals = document.getElementById('bundleTotals');
        var cta = document.getElementById('bundleCta');
        var points = document.getElementById('bundlePoints');
        var nudge = document.getElementById('bundleNudge');
        if (!list || !cta) return;

        if (count === 0) {
            if (empty) empty.style.display = 'block';
            list.innerHTML = '';
            if (totals) totals.style.display = 'none';
            if (nudge) nudge.style.display = 'none';
            cta.disabled = true;
            cta.textContent = 'Add pack to cart';
            if (points) points.textContent = '';
            return;
        }

        if (empty) empty.style.display = 'none';
        if (totals) totals.style.display = 'block';
        cta.disabled = false;

        list.innerHTML = pack.map(function (it, i) {
            var p = BUNDLE[it.key] || { name: it.key, img: '', price: 0 };
            var custom = it.line2 ? (it.line1 + ' · ' + it.line2) : it.line1;
            return '<div class="bl-row"><span class="bl-thumb"><img src="' + p.img + '" alt=""></span>'
                + '<span class="bl-info"><span class="bl-style">' + escapeHtml(p.name) + '</span>'
                + '<div class="bl-custom">' + escapeHtml(custom) + '</div></span>'
                + '<span style="color:var(--sd-muted)">' + money(p.price) + '</span>'
                + '<button class="bl-remove" title="Remove" data-remove="' + i + '">×</button></div>';
        }).join('');

        document.getElementById('btSub').textContent = money(subtotal);
        var discRow = document.getElementById('btDiscRow');
        if (rate > 0) {
            discRow.style.display = 'flex';
            document.getElementById('btDiscLabel').textContent = 'Bundle discount (' + Math.round(rate * 100) + '% off)';
            document.getElementById('btDisc').textContent = '-' + money(discount);
        } else { discRow.style.display = 'none'; }
        document.getElementById('btShip').textContent = freeShip ? 'FREE' : 'Calculated at checkout';
        var was = document.getElementById('btWas');
        if (rate > 0) { was.style.display = 'inline'; was.textContent = money(subtotal); }
        else { was.style.display = 'none'; }
        document.getElementById('btTotal').textContent = money(total);

        var msg;
        if (count === 1) msg = 'Add 1 more tag to unlock 10% off 🎉';
        else if (count === 2) msg = 'Add 1 more to bump your discount to 15%';
        else if (count === 3) msg = 'Add 1 more for 20% off + FREE shipping';
        else msg = 'Max savings unlocked — 20% off + free shipping! 🐾';
        if (nudge) { nudge.style.display = 'block'; nudge.textContent = msg; }

        cta.textContent = 'Add pack to cart · ' + money(total);
        if (points) points.textContent = "You'll earn " + (count * 100) + ' reward points';
    }

    function initBundle() {
        var cards = document.querySelectorAll('.bp-card[data-key]');
        if (!cards.length) return;
        cards.forEach(function (card) {
            var key = card.dataset.key;
            BUNDLE[key] = {
                name: card.dataset.name || key,
                img: card.dataset.img || '',
                price: parseFloat(card.dataset.price || '0') || 0
            };
            var nameEl = document.getElementById('n-' + key);
            var addEl = document.getElementById('add-' + key);
            if (nameEl) nameEl.addEventListener('input', function () { syncAdd(key); });
            if (addEl) addEl.addEventListener('click', function () { addToPack(key); });
        });
        var list = document.getElementById('bundleList');
        if (list) {
            list.addEventListener('click', function (e) {
                var btn = e.target.closest('[data-remove]');
                if (btn) removeFromPack(parseInt(btn.dataset.remove, 10));
            });
        }
        renderBundle();
    }

    /* ===================================================================
       2. Reviews wall — duplicate the Liquid-rendered cards for the loop
       =================================================================== */
    function initReviewsWall() {
        ['rwRow1', 'rwRow2'].forEach(function (id) {
            var row = document.getElementById(id);
            if (row && row.children.length && !row.dataset.looped) {
                row.innerHTML = row.innerHTML + row.innerHTML; // seamless marquee
                row.dataset.looped = '1';
            }
        });
    }

    /* ===================================================================
       3. Scroll-driven palette shift (Classic Pop -> Electric), --sd-* vars
       =================================================================== */
    var SP_A = { primary: '#1565ff', primaryDark: '#0f4fd6', secondary: '#ffcf33', accent: '#ff3d77', heroA: '#eef4ff', heroB: '#fff7e0' };
    var SP_B = { primary: '#5b2bff', primaryDark: '#4a1fe0', secondary: '#ffd233', accent: '#ff2bd6', heroA: '#f3eeff', heroB: '#ffe9fb' };
    function spHex(h) { h = h.replace('#', ''); return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]; }
    function spMix(h1, h2, t) { var a = spHex(h1), b = spHex(h2), m = function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }; return 'rgb(' + m(0) + ', ' + m(1) + ', ' + m(2) + ')'; }
    function spSet(o) {
        var r = document.documentElement.style;
        r.setProperty('--sd-primary', o.primary); r.setProperty('--sd-primary-dark', o.primaryDark);
        r.setProperty('--sd-secondary', o.secondary); r.setProperty('--sd-accent', o.accent);
        r.setProperty('--sd-hero-a', o.heroA); r.setProperty('--sd-hero-b', o.heroB);
    }
    function spAt(t) {
        return {
            primary: spMix(SP_A.primary, SP_B.primary, t), primaryDark: spMix(SP_A.primaryDark, SP_B.primaryDark, t),
            secondary: spMix(SP_A.secondary, SP_B.secondary, t), accent: spMix(SP_A.accent, SP_B.accent, t),
            heroA: spMix(SP_A.heroA, SP_B.heroA, t), heroB: spMix(SP_A.heroB, SP_B.heroB, t)
        };
    }
    function spUpdate() {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var p = max > 0 ? window.scrollY / max : 0; p = Math.max(0, Math.min(1, p));
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        spSet(spAt(e));
    }
    function initScrollShift() {
        // Homepage-only effect: gate on the hero (which never renders on a PDP),
        // NOT on .silidog-home (the marketing-tail sections carry that class too,
        // so the palette shift would wrongly fire on product pages).
        if (!document.querySelector('.silidog-hero')) return;
        var tick = false;
        window.addEventListener('scroll', function () {
            if (!tick) { tick = true; requestAnimationFrame(function () { spUpdate(); tick = false; }); }
        }, { passive: true });
        window.addEventListener('resize', spUpdate, { passive: true });
        spUpdate();
    }

    /* ===================================================================
       4. Count-up stats (animate when in view) — reads data-* on .num
       =================================================================== */
    function countUp(el) {
        var target = parseFloat(el.dataset.target);
        var dec = parseInt(el.dataset.decimals || '0', 10);
        var suffix = el.dataset.suffix || '';
        var dur = 1500, start = performance.now();
        function frame(now) {
            var p = Math.min(1, (now - start) / dur);
            var ease = 1 - Math.pow(1 - p, 3);
            var val = target * ease;
            el.textContent = (dec > 0 ? val.toFixed(dec) : Math.round(val).toLocaleString('en-US')) + suffix;
            if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
    }
    function initCountUp() {
        var proof = document.querySelector('.proof');
        if (!proof) return;
        var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting) {
                    document.querySelectorAll('.proof-stat .num').forEach(countUp);
                    obs.disconnect();
                }
            });
        }, { threshold: 0.4 });
        obs.observe(proof);
    }

    /* ===================================================================
       5. Glow-in-the-dark hero toggle (Day <-> Glow)
       =================================================================== */
    function initGlowToggle() {
        document.querySelectorAll('.glow-toggle').forEach(function (btn) {
            var hero = btn.closest('.hero');
            if (!hero) return;
            btn.addEventListener('click', function () {
                var on = hero.classList.toggle('glow');
                btn.setAttribute('aria-checked', on ? 'true' : 'false');
            });
        });
    }

    /* ===================================================================
       6. SiliSlider spotlight video — click-to-play, first frame as thumb
       =================================================================== */
    function initSliderVideo() {
        document.querySelectorAll('.sl-video').forEach(function (wrap) {
            var vid = wrap.querySelector('video');
            var btn = wrap.querySelector('.sl-play');
            if (!vid || !btn) return;
            btn.addEventListener('click', function () { vid.play(); });
            vid.addEventListener('play', function () { wrap.classList.add('playing'); vid.setAttribute('controls', ''); });
            vid.addEventListener('pause', function () { wrap.classList.remove('playing'); });
        });
    }

    /* ===================================================================
       7. UGC video play/pause toggles
       =================================================================== */
    function initUgcToggles() {
        var PLAY = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
        var PAUSE = '<svg viewBox="0 0 24 24"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>';
        document.querySelectorAll('.ugc-media .ugc-toggle').forEach(function (btn) {
            var v = btn.parentElement.querySelector('video');
            if (!v) return;
            var sync = function () { btn.innerHTML = v.paused ? PLAY : PAUSE; };
            btn.addEventListener('click', function () { v.paused ? v.play() : v.pause(); });
            v.addEventListener('play', sync);
            v.addEventListener('pause', sync);
            sync();
        });
    }

    function init() {
        initBundle();
        initReviewsWall();
        initScrollShift();
        initCountUp();
        initGlowToggle();
        initSliderVideo();
        initUgcToggles();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
